import { validate } from 'pagarme';
import PagarMeV5CardTokenService from 'services/PagarMeV5CardTokenService';
import BillingHTTP from 'utils/billing-http';

/*
 * This class groups some functionalities related to credit card management
 *
 * Usage:
 *   // Configure PAGARME_V5_API_HOST and PAGARME_V5_PUBLIC_KEY in your
 *   // environment variables
 *   const card = {
 *     card_holder_name: 'Card Holder',
 *     card_expiration_date: '01/23',
 *     card_number: '4111111111111111',
 *     card_cvv: '123',
 *   }
 *   const { cardValid } = CardService.validate(card);
 *
 *   if (cardValid) {
 *     CardService.createCardOnPagarMe(card)
 *       .then(cardHash => console.log('card created', cardHash))
 *       .catch((error) => console.error('Unexpected error', error));
 *   } else {
 *     console.error('Invalid card');
 *   }
 */
class CardService {
  validateCard(card) {
    const validations = validate({ card }).card;
    const cardValid = validations.card_holder_name
      && validations.card_expiration_date
      && validations.card_number
      && validations.card_cvv;

    return { cardValid: !!cardValid, ...validations };
  }

  createCard(card) {
    return this.createCardOnPagarMe(card).then(((cardHash) => this.createCardOnBilling(card.card_type, cardHash)));
  }

  createCardOnPagarMe(card) {
    return PagarMeV5CardTokenService.create({
      card_number: card.card_number,
      card_holder_name: card.card_holder_name,
      card_expiration_date: card.card_expiration_date,
      card_cvv: card.card_cvv,
    });
  }

  createCardOnBilling(cardType, cardHash) {
    return BillingHTTP.postContent('/dashboard-api/v2/cards', { card_type: cardType, card_hash: cardHash });
  }

  removeCard(cardId) {
    return BillingHTTP.postContent('/dashboard-api/v2/payment-methods/remove_card', { card_id: cardId });
  }

  getStudentCards(type) {
    return BillingHTTP.getContent('/dashboard-api/v2/cards', { type });
  }
}

export default new CardService();
